import React from 'react';
import { Section } from './shared';
const without = ['Clientes indecisos sin seguimiento', 'Renovaciones sin sistema de aviso', 'Sin guión para manejar objeciones', 'WhatsApp disponible 24/7', 'Trámites manuales todos los días', 'Sin sistema de referidos', 'Sin prompts para seguimiento'];
const realCost = ['Pólizas perdidas que ya eran tuyas', 'Cartera que se achica sola', 'Descuentos que te comen las comisiones', 'Domingos sin familia ni descanso', 'Horas perdidas que podrías usar vendiendo', 'El mismo ciclo el año que viene', 'Clientes que se pierden en silencio'];
export function CostOfInaction() {
  return <div className="w-full bg-navy-deep py-16 text-white sm:py-24" data-id="element-47" data-mp="3dqep8af7mzhu">
      <Section data-id="element-48" data-mp="3im3m25zui2ag">
        <h2 className="text-center font-display text-2xl font-extrabold sm:text-4xl" data-id="element-49" data-mp="3immzpaigq4io">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-50" data-mp="3slcjx9xu0123">
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-id="element-51" data-mp="3slue810xo57d">
            <h3 className="mb-4 font-display text-lg font-bold text-red-300" data-id="element-52" data-mp="3ei16m3letlul">Sin Megapack</h3>
            <ul className="space-y-3" data-id="element-53" data-mp="39gllycn59hcq">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-blue-100/85" data-id="element-54" data-mp="34higws75zb4r">
                  <span aria-hidden="true" data-id="element-55" data-mp="30hgo78jeps1m">❌</span>
                  <span data-id="element-56" data-mp="30irmwtxzw9lv">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-gold/30 bg-white/[0.04] p-6" data-id="element-57" data-mp="13e8bk4rdx7k">
            <h3 className="mb-4 font-display text-lg font-bold text-gold-soft" data-id="element-58" data-mp="3s8mnxnv7tnqd">Costo real</h3>
            <ul className="space-y-3" data-id="element-59" data-mp="3nfbi9q253d01">
              {realCost.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-blue-100/85" data-id="element-60" data-mp="3jerlinlhabef">
                  <span aria-hidden="true" data-id="element-61" data-mp="jsumha9d9o6g">💸</span>
                  <span data-id="element-62" data-mp="f1cnusutfzon">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center" data-id="element-63" data-mp="298n7yaediv76">
          <p className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-64" data-mp="2e89vbcnx1rtp">
            El próximo domingo puede ser diferente. O seguís apagando incendios, o empezás a liderar tu
            estudio.
          </p>
          <p className="text-[15px] leading-relaxed text-blue-100/80" data-id="element-65" data-mp="24hyewqn1pq5x">
            Los que entren hoy no solo compran el Megapack: entran al ecosistema de Librofy.store. Eso
            incluye acceso a futuros materiales exclusivos que iremos liberando para miembros.
          </p>
        </div>
      </Section>
    </div>;
}